import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import * as DataSourceActions from "./data-source.actions";
import { DataSourceSummary } from "./union.model";

export const dataSourcesFeatureKey = "dataSources";

export interface DataSourceState extends EntityState<DataSourceSummary> {
  loading: boolean;
}

export const dataSourceAdapter: EntityAdapter<DataSourceSummary> =
  createEntityAdapter<DataSourceSummary>({
    selectId: (ds) => ds.uuid,
  });

export const initialDataSourceState: DataSourceState =
  dataSourceAdapter.getInitialState({
    loading: false,
  });

export const dataSourceReducer = createReducer(
  initialDataSourceState,
  on(DataSourceActions.loadDataSources, (state) => {
    return { ...state, loading: true };
  }),
  on(DataSourceActions.loadDataSourcesSuccess, (state, action) =>
    dataSourceAdapter.setAll(action.dataSources, { ...state, loading: false }),
  ),
  on(DataSourceActions.loadDataSourcesFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(DataSourceActions.addDataSourceSuccess, (state, action) =>
    dataSourceAdapter.upsertOne(action.dataSource, state),
  ),
  on(DataSourceActions.updateDataSourceSuccess, (state, action) =>
    dataSourceAdapter.upsertOne(action.dataSource, state),
  ),
  on(DataSourceActions.deleteDataSourceSuccess, (state, action) =>
    dataSourceAdapter.removeOne(action.id, state),
  ),
);
